import * as types from "./types";

/**
 * Convert the number of a module and level into a single number where
 *
 *  - the hundreds place is the module number
 *  - the tens and ones place is a zero padded level number
 *
 * For example, if module 3 and level 2 is passed, this will return 302.
 *
 * This is used to easily weight and compare levels against one another for the
 * purpose of determining progress through the course.
 *
 * @param Number|Object module
 * @param Number|Object level
 */
const toProgressInt = (module, level) => {
  if (typeof module === "object") {
    module = module.number;
  }

  if (typeof level === "object") {
    level = level.number;
  }

  return Number(`${module}${String(level).padStart(2, "0")}`);
};

export default {
  [types.MODULE_OPEN](state, { module }) {
    const index = state.modules.findIndex(m => m.node_id === module.node_id);

    if (index < 0) {
      throw new Error(`Update failed; no module with node_id [${module.node_id}] exists.`);
    }

    state.modules.splice(index, 1, { ...module, active: true });
  },

  [types.MODULE_UPDATE](state, { module }) {
    const index = state.modules.findIndex(m => m.node_id === module.node_id);

    if (index < 0) {
      throw new Error(`Update failed; no module with node_id [${module.node_id}] exists.`);
    }

    state.modules.splice(index, 1, module);
  },

  [types.COURSE_UPDATE](state, { modules }) {
    let m = 1;

    modules.forEach(module => {
      module.number = m++;
      let l = 1;

      module.levels.forEach(level => {
        level.number = l++;
        level.weight = toProgressInt(module, level);
      });
    });

    state.modules = modules.map(m => ({ ...m, active: false }));
  },

  /**
   * update the local store's progress tracker
   */
  [types.PROGRESS_UPDATE](state, { module, level }) {
    state.progress = {
      module: typeof module === "object" ? module.number : 1,
      level: typeof level === "object" ? level.number : 0,
    };

    state.progress.weight = toProgressInt(state.progress.module, state.progress.level);
  },

  // open the detail view for a level
  [types.COURSE_SET_LEVEL](state, { id }) {
    state.currentLevelId = id;
  },

  /**
   * Cache the level details (primarily content) for a
   */
  [types.LEVEL_UPDATE](state, { id, payload }) {
    const module = state.modules.find(m => m.levels.map(l => l.node_id).includes(id));

    if (!module) {
      return;
    }

    const levelIndex = module.levels.findIndex(l => l.node_id === id);

    if (levelIndex < 0) {
      console.warn(
        `Could not update level details. The node id [${id}] found in the details payload does not match any level id`
      );
      return;
    }

    module.levels.splice(levelIndex, 1, {
      ...module.levels[levelIndex],
      ...payload,
    });
  },

  [types.LOADING_START](state) {
    state.loading++;
  },

  [types.LOADING_STOP](state) {
    state.loading--;
  },
};
